import React, { useEffect } from 'react'
import { Typography, useTheme } from '@material-ui/core'

import { ChatMessageContent, NavigationResponse } from '../../../types'
import { Container } from '../../../../../../components/Container'
import { useHistory } from 'react-router-dom'
import { useLoriState } from '../../../../../../contexts/LoriContext'

interface Props {
    message: ChatMessageContent
}

export const NavigateCard: React.FC<Props> = ({ message }) => {
    if (!message.function_call_response) return null
    const navigationResponse: NavigationResponse = message.function_call_response as NavigationResponse
    const history = useHistory()
    const theme = useTheme()
    const { freshMessageIds, removeFromFreshMessageIds } = useLoriState()

    // navigate to the url if this is the initial message AND it's a fresh message
    useEffect(() => {
        if (
            navigationResponse.initial &&
            message.id &&
            freshMessageIds.has(message.id)
        ) {
            // Small delay to ensure message is shown before navigation
            const timer = setTimeout(() => {
                // Navigate to the URL
                history.push(navigationResponse.url)

                // Remove the message ID from freshMessageIds after navigation
                if (message.id) {
                    removeFromFreshMessageIds(message.id)
                }
            }, 750)

            return () => clearTimeout(timer)
        }
    }, [
        navigationResponse.initial,
        message.id,
        freshMessageIds,
        history,
        navigationResponse.url,
        removeFromFreshMessageIds,
    ])

    return (
        <Container
            style={{
                flexDirection: 'column',
            }}
        >
            <Container>
                <Typography
                    component="div"
                    style={{
                        padding: theme.spacing(1, 1),
                        borderRadius: theme.shape.borderRadius * 3,
                        backgroundColor: theme.palette.grey[100],
                        color: theme.palette.text.primary,
                        whiteSpace: 'pre-wrap',
                    }}
                >
                    {navigationResponse.message}
                </Typography>
            </Container>
        </Container>
    )
}
